import Vue from 'vue'
import db from '../db';
import commonRepository from './commonRepository';
import { translateActuations, transformActuationsToJSON } from '../services/translatingActuationsService';
import { combineActuations } from '../services/combineActuationsService';

const table = db.actuations;

const actuationsRepository = {
  ...commonRepository(table),
  async addActuation(item) {
    try {
      return await table.add(item);
    } catch (error) {
      Vue.prototype.$toast.open({ 
        message: "Hubo un problema en la creación de la actuación Offline", 
        position: 'top-right', 
        type: 'error', 
        duration: 10000, 
      });
      throw error;
    }
  },
  async getAllActuations(appOfflineActuations) {
    try {
      let translatedActuations = translateActuations(appOfflineActuations);
      const allActuations = combineActuations(await translatedActuations, await actuationsRepository.getAll());
      return await allActuations;
    } catch (error) {
      throw error;
    }
  },
  async getActuationsAmount(appOfflineActuations) {
    try {
      const appOfflineActuationsToJSON = await transformActuationsToJSON( await appOfflineActuations);
      const actuationsRepositoryToJSON = await transformActuationsToJSON( await actuationsRepository.getAll());
      return await appOfflineActuationsToJSON.concat(actuationsRepositoryToJSON).length;
    } catch (error) {
      throw error;
    }
  },
  async updateActuation(id, item) {
    try {
      return await table.update(id, item);
    } catch (error) {
      throw error;
    }
  },
};

export default actuationsRepository;